// Auto-refactored from translations.js on 2026-08-19
// Locale: ko

const ko = {
  wieMoeglich: { question: '어떻게 가능할까요?', answer: '우리는 가치 사슬을 새롭게 설계했습니다.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK의 길',
    fazit: '단축된 공급망으로 가장 큰 비용 항목이 사라집니다.',
    fazitBigPre: '이를 통해 가능한 할인율은 최대',
    fazitBigValue: '80%',
    steps: [ '광산', '연마 공방', '인증', '최종 고객' ]
  },
  nav: { language: '언어', contact: '연락처' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: '독보적인 기회',
    subtitle: '미래 지향적인 자산 구축.',
    description: 'STIG ROCK은 천연 다이아몬드, 지속 가능한 자산 형성, 그리고 독보적인 커뮤니티에 대한 접근을 제공하는 글로벌 플랫폼입니다.',
    scroll: '아래로 스크롤하여 확인'
  },
  disclaimer: {
    overline: '법적 고지',
    title: 'Disclaimer',
    paragraphs: [
      '이 프레젠테이션은 정보 제공만을 목적으로 하며 금융, 투자 또는 세무 자문을 구성하지 않습니다.',
      'STIG ROCK은 금융 상품이 아니며, 실물 자산으로서의 천연 Diamond를 의미합니다.',
      '가치 변동, 수익 또는 이익에 대해 어떠한 보장도 하지 않습니다. 과거의 성과가 미래의 결과를 나타내지는 않습니다.',
      '수수료와 관련된 모든 계산 방식은 예시일 뿐이며 보장을 의미하지 않습니다.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ '체계적인', '구조 위에 구축' ],
    body: 'STIG Group은 투명성, 책임감, 장기적 가치를 바탕으로 설립된 글로벌 기업입니다. 모든 브랜드, 모든 프로젝트 및 모든 Partner십은 어떠한 지름길이나 예외 없이 단일한 표준을 따릅니다.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ '체계적인', '구조 위에 구축' ],
        body: 'STIG Group은 투명성, 책임감, 장기적 가치를 바탕으로 설립된 글로벌 기업입니다. 모든 브랜드, 모든 프로젝트 및 모든 Partner십은 어떠한 지름길이나 예외 없이 단일한 표준을 따릅니다.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ '독점적인 Diamond', '세계' ],
        body: 'STIG ROCK은 고품질 GIA 인증 Diamond를 투명한 구조 및 독점적인 고객 경험과 결합한 STIG Group의 현대적인 컨셉입니다. 명확한 솔루션 계획, 전문적인 프로세스 및 글로벌 지향성을 갖추고 있습니다.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ '글로벌 Diamond', '무역' ],
        body: 'STIG International은 STIG Group의 일원으로 GIA 인증 Diamond의 국제 무역을 전문으로 합니다. 글로벌 Partner십을 통한 품질, 신뢰 및 현대적인 무역 구조에 중점을 둡니다.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ '광산에서부터', '시작되는 책임' ],
        body: 'ETHICAL MINES는 책임 있는 채굴, 추적 가능한 출처 및 분쟁 없는 Diamond를 상징합니다. 광산에서 시장까지 — 전체 공급망에 걸친 투명성, 무결성 및 장기적 책임을 위한 빈틈없는 기록 관리.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: '다이아몬드',
    stigDrawback: '실질적 가치 저장 수단',
    overline: '기회',
    title: '자산 구축을 위한 기회',
    subtitle: '기존 방식과의 비교.',
    items: [
      { tag: 'Trading', name: '외환 또는 암호화폐', drawback: '매우 투기적, 예측 불가능, 복잡' },
      { tag: 'Aktien', name: '주식 거래', drawback: '변동성 위험, 전문 지식 필요, 시간 소모' },
      { tag: 'Krypto', name: '거래', drawback: '변동성, 규제 위험, 보안 취약점' }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: '과소평가된 기회',
    body: 'Diamond는 수년간 가장 안정적인 가치와 기회를 제공하는 투자 형태 중 하나였지만, 지금까지는 소수만이 이 잠재력을 활용해 왔습니다.',
    callout: 'STIG ROCK을 통해 우리는 처음으로 모든 사람에게 이러한 탁월한 기회에 대한 접근을 제공합니다.'
  },
  wertentwicklung: {
    overline: '가치 추이 1995 — 2025',
    title: '가치에 관한 이야기.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: '1995 — 2025년 이후 추이'
  },
  hauptgruende: {
    overline: '주요 이유',
    title: 'Diamond를 선택해야 하는 6가지 이유',
    lead: 'Diamond는 통화나 금융 시스템과 독립적으로 존재하며 수세기 동안 가치를 유지해 온 실물 자산입니다.',
    items: [
      { n: '01', title: '위기에도 강한 가치 안정성', body: '실물 자산 보장. 통화 및 금융 시스템으로부터 독립적.' },
      { n: '02', title: '궁극의 이동성', body: '작고 숨기기 쉬우며 운반이 용이.' },
      { n: '03', title: '다각화 및 희소성', body: '공급 부족 및 천연의 한계.' },
      { n: '04', title: '장기적 성장', body: '1995년 이후 +185%.' },
      { n: '05', title: '투명성 및 독점성', body: '4 Cʼs 보장: Carat, Color, Clarity, Cut.' },
      { n: '06', title: '왕실의 비축 자산', body: '왕실조차도 Diamond를 자산 비축 수단으로 활용.' }
    ]
  },
  markt: {
    overline: '시장 규모',
    title: '99 — 108 Mrd. USD',
    sub: '2025년 거래 규모',
    forecast: '2032 / 2034년 전망: 완만한 성장 시 (~연 4 – 5 %) 약 140 – 168 Mrd. USD.',
    source: '출처: Fortune Business Insights'
  },
  innovation: {
    overline: 'STIG INTERNATIONAL — Innovation',
    title: '혁신. 세계 최초.',
    body: 'STIG ROCK은 사람들이 Diamond 시장에서 가치 상승뿐만 아니라 수동적 소득을 창출할 수 있게 해주는 세계 최초의 플랫폼입니다.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      '등록 번호 DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: '기업 소개',
    titleLines: [ '국제적', '구조', '명확한 비전' ],
    body: 'STIG ROCK은 신뢰, 보안 및 장기적 구조에 초점을 맞추어 Diamond 시장을 더욱 투명하고 현대적이며 고객 중심으로 만들기 위해 설립되었습니다.'
  },
  sicherheit: {
    overline: '품질 및 보안',
    title: 'Gemological Institute of America',
    body: '귀하의 Diamond를 위한 인증된 전문성. GIA는 최고의 정밀도와 수년간의 경험으로 각 원석을 감정하며, 우리 기업과 고객을 위해 신뢰할 수 있는 가치 평가를 제공합니다.',
    transparency: '모든 Diamond는 최고 품질 표준을 충족하며 저명한 기관의 검사 및 인증을 받습니다. 각 원석은 고유하며 개별 인증서가 발급됩니다.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: '독보적인 제품 혁신',
    sub: '$1K에서 $100K+까지 6단계 Solution Pläne — 각 단계별로 월별 및 전체 기간에 걸쳐 증가하는 할인 혜택을 제공합니다.',
    recommended: '인기',
    oneYear: '1년',
    rowLabels: {
      delivery: '배송 기간',
      price: '제품 가격',
      carat: 'Carat',
      monthly: '할인 (월)',
      totalDiscount: '할인 (총)',
      duration: '기간'
    },
    headers: {
      plan: 'Plan',
      from: '최소',
      carat: 'Carat',
      monthly: '할인 / 월',
      total: '할인 총계',
      duration: '기간'
    },
    duration: '1년',
    footnote: '모든 가격 정보는 보증되지 않으며 품질, 수요 및 현재 시장 상황에 따라 달라질 수 있습니다. Solution 플랜은 2년으로도 가능합니다.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-Paket',
    title: 'VIP-Paket으로 더 많은 혜택을',
    sub: 'Solution Plan과 VIP-Paket을 결합하여 최대 3%의 추가 가격 혜택을 누리세요. 전체 할인율을 높이고 더욱 매력적인 조건을 확보하실 수 있습니다.',
    rowLabels: {
      delivery: '배송 기간',
      price: '제품 가격',
      carat: 'Carat',
      monthly: '할인 (월)',
      totalDiscount: '할인 (총)',
      vip1: 'VIP-Paket 1 (+1%)',
      vip2: 'VIP-Paket 2 (+2%)',
      vip3: 'VIP-Paket 3 (+3%)'
    },
    footnote: '모든 가격 정보는 보증되지 않으며 품질, 수요 및 현재 시장 상황에 따라 달라질 수 있습니다.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'VIP-Paket으로 더 많은 혜택을',
    sub: 'Solution Plan과 VIP-Paket을 결합하여 최대 3%의 추가 가격 혜택을 누리세요. 전체 할인율을 높이고 더욱 매력적인 조건을 확보하실 수 있습니다.',
    options: [
      {
        key: 'deliver',
        title: 'VIP-Paket으로 더 많은 혜택을',
        body: '귀하의 DS-Plan* 가격에 따른 Diamond (Karat)'
      },
      {
        key: 'sellToUs',
        title: '당사에 판매',
        body: '귀하가 지불한 구매 가격으로 당사에 Diamond를 다시 판매할 수 있습니다.'
      },
      {
        key: 'sellThirdParty',
        title: '제3자에게 판매',
        body: '자유 시장에서 제3자에게 Diamond를 판매할 수 있습니다.'
      }
    ],
    footnote: '*DS-Plan은 Solution 플랜을 의미합니다.'
  },
  tradWeg: {
    overline: '전통적인 무역',
    title: '전통적인 경로',
    sub: 'Diamond가 최종 고객에게 도달하기 전까지, 광산의 원석 가격 대비 중간, 도매 및 소매 단계를 거치며 상당한 마진이 발생합니다.',
    steps: [
      { title: 'Mine', subtitle: '원석' },
      { title: '중간 상인', subtitle: '원석 매입' },
      { title: '연마소', subtitle: '보석용 Diamond 연마' },
      { title: 'Zertifizierung', subtitle: 'GIA와 같은 공인 기관' },
      { title: 'Diamond 거래소', subtitle: '도매업체에 판매' },
      { title: '도매', subtitle: '소매업체에 판매' },
      { title: '소매', subtitle: '예: 보석상' },
      { title: '최종 고객', subtitle: 'Diamond 구매' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-Pakete',
    sub: '귀하가 체결한 모든 Solution 플랜에 대해 12개월 동안 유효합니다. VIP-Paket에 따라: +1%에서 +3% 추가 할인',
    cardKicker: '추가 – 모든',
    cardKicker2: 'Solution 플랜에',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: '할인이 저축이 됩니다',
      body: '매달 나가는 지출 대신 매달 쌓이는 저축. 할인에서 저축이 발생하며, 이는 매달 개인 자금으로 지불하던 비용을 충당하게 해줍니다.',
      line1Label: 'DS-Plan 최소',
      line1Value: '$5.000',
      line2Label: '월 할인',
      line2Value: '3%',
      line3Label: 'VIP-Paket 3',
      line3Value: '+3%',
      resultLabel: '월별 저축액',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: '어떻게 가능한가요?',
    title: '우리는 가치 사슬을 재정의했습니다.',
    traditionalTitle: '전통적인 경로',
    traditionalSteps: [
      'Mine — 원석',
      '중간 상인 — 매입',
      '연마소 — 가공',
      'Zertifizierung (GIA)',
      'Diamond 거래소 — 도매',
      '도매 → 소매',
      '보석상 → 최종 고객'
    ],
    traditionalNote: 'Diamond가 최종 고객에게 도달하기 전까지, 여러 단계를 거치며 상당한 마진이 발생합니다.',
    stigTitle: 'STIG ROCK 경로',
    stigSteps: [ '직접 구매 — 광산 원석', 'Partner를 통한 연마 및 인증', '최종 고객 및 B2B 고객에 판매', '연간 최대 4회의 무역 사이클' ],
    stigNote: '우리는 순환 구조를 단축하여 발생한 마진을 고객에게 할인 혜택으로 제공합니다. DS-Plan 기간 동안 최대 4회의 무역 사이클이 발생합니다.'
  },
  optionen: {
    overline: '귀하의 기회',
    title: 'Solution 플랜 종료 후',
    items: [
      { title: '배송 받기', body: '귀하의 DS-Plan 가격에 따른 Diamond (Karat).' },
      { title: '당사에 판매', body: '귀하가 지불한 구매 가격으로 환매.' },
      { title: '제3자에게 판매', body: '자유 시장에서 Diamond를 매도.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution 플랜 — 독보적인 제품 혁신',
    title: '간편한 시작',
    steps: [
      { n: '01', icon: 'signup', title: '회원가입', body: '추천인에게 문의하여 무료 계정을 생성하십시오!' },
      { n: '02', icon: 'cart', title: '제품 구매', body: '$ 250,- 부터 가능' },
      { n: '03', icon: 'discount', title: '할인 혜택', body: '매달 제공되는 할인 혜택을 받으십시오.' }
    ]
  },
  business: {
    overline: '보너스 유형',
    title: '가장 쉽고 공정한 방법.',
    sub: '성공적인 비즈니스 구축을 위한 5가지 보너스 유형.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Level 3까지, Pearl / Ruby 등급부터 지급.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Sapphire부터 — 깊이 제한 없음.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Infinity Bonus 기준 – Level 5까지 · 자격 요건 없음.'
      },
      { name: 'World Pools', icon: 'world', value: '3%', desc: '전 세계 매출의 3% Pool.' },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Diamond (Karat)로 지급되는 일회성 보너스.'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: '이 보너스는 Level 3까지 새로 가입된 모든 Solution 플랜에 대해 지급됩니다. 낮은 자격 요건으로 각 단계를 활성화할 수 있습니다.',
    total: '최대 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: '가입 즉시',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'Pearl 등급부터',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'Ruby 등급부터',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Sapphire 등급부터 Infinity Bonus 계획 자격이 주어집니다. 3% 보너스를 시작으로, 각 등급 달성 시 추가 비율이 합산됩니다. 팀 내 Partner가 동일 자격인 경우 등급 간 차액을 지급받습니다.',
    exampleTitle: '예시',
    exampleRows: [
      { label: '귀하가 Blue Diamond인 경우', value: '12%' },
      { label: 'Partner가 Sapphire인 경우', value: '3%' }
    ],
    exampleResult: { label: '귀하의 Infinity Bonus', value: '9%' },
    totalNote: '팀 내 모든 Solution 플랜에 대해 최대 24%의 Infinity Bonus — 깊이 제한 없음.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: '이 보너스를 통해 팀의 성공을 공유합니다. Partner의 Infinity Bonus 중 5%를 Matching Bonus로 받게 되며, 이는 5단계 깊이까지 적용됩니다.',
    note: '팀 내 모든 Infinity Bonus 지급액 기준 – Level 5까지. 가입 즉시 – 자격 요건 없음.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: '총 최대',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '전 세계 매출의 3%가 3개의 개별 Pool에 균등하게 적립됩니다. 특정 등급을 달성하면 각 Pool에 참여할 자격이 주어집니다.',
    forever: '한 번 달성하면 – 평생 공유!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'Blue Diamond부터' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'Purple Diamond부터' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'Double Diamond Elite부터' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: '전체',
    totalValue: '3%',
    totalSuffix: '글로벌 매출 기준'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Diamond 등급부터 Rang Bonus를 받게 됩니다. 이 보너스는 Diamond (Karat)로 지급되는 일회성 혜택입니다.',
    highlight: 'Diamond (Karat) 총 가치',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · 커리어 등급',
    title: '커리어 등급',
    sub: '각 커리어 등급 달성을 위해 역사적 누적 매출(HG)이 산정됩니다. Sapphire 등급부터는 매출이 여러 팀에 분산되어야 합니다. Ruby 이상의 등급을 위해서는 Solution 플랜을 보유한 최소 2명의 직접 추천 Partner가 필요합니다.',
    forever: '한 번 달성하면 – 평생 유지!',
    footnote: 'HV = 역사적 누적 매출.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '직접 추천 2명', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k 보너스' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k 보너스', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k 보너스', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k 보너스', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k 보너스', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M 보너스', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M 보너스', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M 보너스', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: '우리와 함께 시작하십시오',
    title: '바로 지금이 적기입니다.',
    body: '이 비즈니스 모델은 새로운 기준을 제시하며 지속 가능한 성공을 위한 모든 요소를 결합했습니다. 지금 가입하고, Solution 플랜을 선택하여 이 특별한 기회를 활용하십시오.',
    hint: '이 프레젠테이션에 초대하신 분께 문의하십시오 — 등록 링크를 안내해 드릴 것입니다.',
    formName: '성함',
    formEmail: '이메일',
    formPhone: '전화번호',
    formSubmit: '문의하기',
    success: '감사합니다 — 확인 후 정중히 연락드리겠습니다.',
    callCta: '전화하기',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: '법적 고지 및 Disclaimer',
    disclaimer: '이 프레젠테이션은 정보 제공만을 목적으로 하며 금융, 투자 또는 세무 자문을 구성하지 않습니다. STIG ROCK은 금융 상품이 아니며, 실물 자산으로서의 천연 Diamond를 의미합니다. 가치 변동, 수익 또는 이익에 대해 어떠한 보장도 하지 않습니다. 과거의 성과는 미래의 결과를 보장하지 않습니다. 수수료 관련 계산은 예시일 뿐 보장이 아닙니다. 내용 변경 가능 — 번역본 (공식 번역 아님).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. All rights reserved.',
    version: 'Version: DS-12-2025 V3'
  },
  misc: { next: '다음 섹션' }
};

export default ko;
